import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Star, ListBullets } from '@phosphor-icons/react';

import { dummyCategories, dummyProducts } from '../dummyData';
import categoryListIcon from '../../adminAssets/images/templates/category-list-icon.svg';
import useProductList from '../../hooks/useProductList';
import useProductCategory from '../../hooks/useProductCategory';

const TemplateProductCategory = ({ colors = {}, isMobileHome = false, isMobileProduct = false, websiteData = {} }) => {
    const [sortBy, setSortBy] = useState('popular-desc');
    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);

    const { fetchProductCategoryByShop, data: productCategory } = useProductCategory();

    const { fetchProductList, data: productList, total: productListTotal } = useProductList();

    useEffect(() => {
        if (websiteData?.storeId) {
            fetchProductCategoryByShop(websiteData.storeId);
        }
    }, [websiteData?.storeId]);

    useEffect(() => {
        if (!websiteData?.storeId) return;
        fetchProductList({
            companyId: websiteData.storeId,
            categoryIds: filterCategoryId,
            sortBy: sortBy.includes('-') ? sortBy.split('-')[0] : sortBy,
            sortType: sortBy.includes('-') ? sortBy.split('-')[1] : undefined,
            skip: page * 20,
            take: 20
        });
    }, [websiteData?.storeId, filterCategoryId, page, sortBy]);

    const totalPages = Math.ceil(productListTotal / 20) || 1;
    const isFirstPage = page === 0;
    const isLastPage = page + 1 >= totalPages;

    return (
        <div className="container" style={{ marginBottom: '64px', paddingBottom: '24px' }}>
            {/* Category title + Sort bar on same row */}
            {!isMobileHome && (
                <div className="d-flex align-items-center mb-4 gap-4">
                    <div className="d-none d-md-block" style={{ minWidth: '180px' }}>
                        <h6 className="mb-0 fw-bold d-flex align-items-center gap-6" style={{ fontSize: '16px', color: '#111' }}>
                            <img src={categoryListIcon} alt="Category" style={{ width: '20px', height: '20px' }} /> Category
                        </h6>
                    </div>
                    <div className="flex-grow-1">
                        <div
                            className="rounded-8 px-12 px-md-4 py-10 d-flex flex-wrap justify-content-between align-items-center gap-3"
                            style={{ backgroundColor: colors.sortByBg || '#F4F4F4' }}
                        >
                            <div className="d-flex flex-wrap align-items-center gap-10 gap-md-3">
                                <span className="text-12 fw-medium" style={{ color: '#000000', whiteSpace: 'nowrap' }}>
                                    Sort by
                                </span>
                                <div className="d-flex flex-wrap gap-5">
                                    <button
                                        className="text-12 fw-medium px-8 px-md-3 py-1"
                                        style={{
                                            backgroundColor: sortBy === 'popular-desc' ? colors.categoryActive || '#2563EB' : '#FFFFFF',
                                            color: sortBy === 'popular-desc' ? '#FFFFFF' : '#000000',
                                            border:
                                                sortBy === 'popular-desc'
                                                    ? `1px solid ${colors.categoryActive || '#2563EB'}`
                                                    : '1px solid transparent',
                                            borderRadius: '9999px',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={() => {
                                            setSortBy('popular-desc');
                                            setPage(0);
                                        }}
                                    >
                                        Popular
                                    </button>
                                    <button
                                        className="text-12 fw-medium px-8 px-md-3 py-1"
                                        style={{
                                            backgroundColor: sortBy === 'newest-desc' ? colors.categoryActive || '#2563EB' : '#FFFFFF',
                                            color: sortBy === 'newest-desc' ? '#FFFFFF' : '#000000',
                                            border:
                                                sortBy === 'newest-desc'
                                                    ? `1px solid ${colors.categoryActive || '#2563EB'}`
                                                    : '1px solid transparent',
                                            borderRadius: '9999px',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={() => {
                                            setSortBy('newest-desc');
                                            setPage(0);
                                        }}
                                    >
                                        New
                                    </button>
                                    <button
                                        className="text-12 fw-medium px-8 px-md-3 py-1"
                                        style={{
                                            backgroundColor: sortBy === 'best-seller' ? colors.categoryActive || '#2563EB' : '#FFFFFF',
                                            color: sortBy === 'best-seller' ? '#FFFFFF' : '#000000',
                                            border:
                                                sortBy === 'best-seller'
                                                    ? `1px solid ${colors.categoryActive || '#2563EB'}`
                                                    : '1px solid transparent',
                                            borderRadius: '9999px',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={() => {
                                            setSortBy('best-seller');
                                            setPage(0);
                                        }}
                                    >
                                        Best Seller
                                    </button>
                                </div>
                            </div>
                            <div
                                className="d-none d-md-flex align-items-center gap-2 gap-md-4 text-12 fw-medium ms-auto"
                                style={{ color: '#000000' }}
                            >
                                <span style={{ whiteSpace: 'nowrap' }}>
                                    {page + 1}/{totalPages}
                                </span>
                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: 'transparent',
                                            border: '1px solid #000000',
                                            flexShrink: 0,
                                            opacity: isFirstPage ? 0.5 : 1
                                        }}
                                        disabled={isFirstPage}
                                        onClick={() => setPage(page - 1)}
                                    >
                                        <i className="ph ph-caret-left" style={{ fontSize: '14px', color: '#000000' }}></i>
                                    </button>
                                    <button
                                        className="btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: 'transparent',
                                            border: '1px solid #000000',
                                            flexShrink: 0,
                                            opacity: isLastPage ? 0.5 : 1
                                        }}
                                        disabled={isLastPage}
                                        onClick={() => setPage(page + 1)}
                                    >
                                        <i className="ph ph-caret-right" style={{ fontSize: '14px', color: '#000000' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="d-flex gap-4">
                {/* Left: Category list */}
                <div style={{ minWidth: '180px' }} className="flex-shrink-0 d-none d-lg-block pt-3">
                    <div className="d-flex flex-column gap-14 ps-2">
                        <Link
                            to="#"
                            className={`text-decoration-none text-13 fw-normal`}
                            style={{ color: filterCategoryId === undefined ? colors.categoryActive || '#2563EB' : '#999999' }}
                            onClick={(e) => {
                                e.preventDefault();
                                setFilterCategoryId(undefined);
                                setPage(0);
                            }}
                        >
                            All Product
                        </Link>
                        {Array.isArray(productCategory) &&
                            productCategory.map((cat) => (
                                <Link
                                    key={cat.id}
                                    to="#"
                                    className={`text-decoration-none text-13 fw-normal`}
                                    style={{ color: filterCategoryId === cat.id ? colors.categoryActive || '#2563EB' : '#999999' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setFilterCategoryId(cat.id);
                                        setPage(0);
                                    }}
                                >
                                    {cat.name}
                                </Link>
                            ))}
                    </div>
                </div>

                {/* Right: Product Grid */}
                <div
                    className={`flex-grow-1 my-20 ${isMobileHome || isMobileProduct ? '' : 'ps-20'}`}
                    style={{ borderLeft: isMobileHome || isMobileProduct ? 'none' : '1px solid #E5E5E5' }}
                >
                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-4 g-4">
                        {Array.isArray(productList) && productList.length > 0 ? (
                            productList.map((product, idx) => {
                                const badgeStyles = [
                                    { text: 'Best Sale', bg: '#2563EB' }, // Primary blue
                                    { text: 'New', bg: '#f59e0b' }, // orange/amber
                                    { text: 'Sale 50%', bg: '#dc3545' }, // red
                                    { text: 'Sale 50%', bg: '#dc3545' } // red
                                ];
                                const badge = badgeStyles[idx % 4];

                                return (
                                    <div key={product.id || idx} className="col">
                                        <Link
                                            to={`/product-details/${encodeURIComponent(product.slug || '-maharani-indonesian-style-dress')}`}
                                            className="card h-100 overflow-hidden shadow-none text-decoration-none"
                                            style={{ border: '1px solid #D9D9D9', borderRadius: '8px' }}
                                        >
                                            {/* Product Badge */}
                                            <div
                                                className="position-absolute start-0 top-0 text-white px-10 py-1 z-1"
                                                style={{
                                                    fontSize: '10px',
                                                    backgroundColor: badge.bg,
                                                    borderRadius: '8px 0 8px 0',
                                                    display: 'none' // Hidden by default, can logic later
                                                }}
                                            >
                                                {badge.text}
                                            </div>
                                            {/* Product Image */}
                                            <div style={{ aspectRatio: '1/1', backgroundColor: '#FFFFFF', maxHeight: '200px' }}>
                                                <img
                                                    src={
                                                        product.photoData && product.photoData.length > 0
                                                            ? product.photoData[0].url
                                                            : '/assets/images/no-image.png'
                                                    }
                                                    className="w-100 h-100"
                                                    style={{ objectFit: 'cover', transition: '0.2s linear' }}
                                                    alt={product.name}
                                                />
                                            </div>
                                            {/* Product Details */}
                                            <div className="p-10 d-flex flex-column" style={{ flex: 1 }}>
                                                <h6 className="text-14 fw-bold mb-3" style={{ lineHeight: '1.4', color: '#000000' }}>
                                                    {product.name}
                                                </h6>
                                                <div className="mt-auto d-flex flex-wrap align-items-center gap-1 mb-8">
                                                    <div className="d-flex align-items-end gap-1">
                                                        <span
                                                            className="fw-bold"
                                                            style={{ fontSize: '14px', lineHeight: '1', color: '#000000' }}
                                                        >
                                                            Rp
                                                            {product.discountPrice > 0 && product.discountPrice < product.price
                                                                ? product.discountPrice?.toLocaleString()
                                                                : product.price?.toLocaleString()}
                                                        </span>
                                                        {Number(product.discountPrice) > 0 && product.discountPrice < product.price && (
                                                            <span
                                                                className="fw-medium text-decoration-line-through "
                                                                style={{ fontSize: '14px', lineHeight: '1', color: '#999999' }}
                                                            >
                                                                Rp{product.price?.toLocaleString()}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center gap-2 text-10 mb-2">
                                                    <span style={{ color: '#999999' }}>{product.rating || '4.8'}</span>
                                                    <Star weight="fill" className="text-warning" size={10} />
                                                    <span style={{ color: '#999999' }}>({product.reviews || '17k'})</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-12 py-5 text-center text-muted">No Product Found</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateProductCategory;
